<div id="loaderEle" [hidden]="!show">
  <!--<ng2-slim-loading-bar></ng2-slim-loading-bar>-->
  <div #progress class="slim-loader">
  </div>

  <!--<div class="loader"></div>-->

</div>
